import { PageOptions } from '@graphcommerce/framer-next-pages'

import { StoreConfigDocument } from '@graphcommerce/magento-store'
import { GetStaticProps } from '@graphcommerce/next-ui'
import { getWidgetsData, widgetsDataType, allWidgetsData, slidersWidgets } from '../api/landingPage/widgets';
import { DevLayoutNavigation, DevLayoutNavigationProps } from '../components'
import { LayoutDocument } from '../components/Layout/Layout.gql'



import BlogSection from '../components/Routes/Home/BlogSection';
import DiscountWidgets from '../components/Routes/Home/DiscountWidgets';
import AdsSlider from '../components/Routes/Home/adsSlider';

import NewSelection from '../components/Routes/Home/newSelection';
import IconMobile from '../components/icons/mobile';
import SpecialDiscount from '../components/widgets/specialDiscount';
import { DefaultPageDocument, DefaultPageQuery } from '../graphql/DefaultPage.gql'
import { MegaMenuContentDocument, MegaMenuContentQuery } from '../graphql/MegaMenuContent.gql';
import { storeLogoDocument, storeLogoQueryVariables } from '../graphql/storeLogo.gql';
import { graphqlSharedClient, graphqlSsrClient } from '../lib/graphql/graphqlSsrClient';



type Props = DefaultPageQuery & {

  widgetsData: widgetsDataType,
  sliders: any,
} & MegaMenuContentQuery & storeLogoQueryVariables;



type RouteProps = { url: string }
type GetPageStaticProps = GetStaticProps<DevLayoutNavigationProps, Props, RouteProps>

export type HotAndNewCardProps = {
  image?: string
  video?: string
  description: string
  title: string
  url: string
  classes?: {
    wrapper: string
  }
  theme?: 'dark' | 'light'
}


function CmsPage(props: Props) {

  const { widgetsData, sliders } = props

  return (<>
    <AdsSlider images={[
      "/widgets/images/bs3-min.png",
      "/widgets/images/bs1-min.png",
      "/widgets/images/bs6-min.png",
      "/widgets/images/bs5-min.png"]}
      className='my-6'

    />
    <SpecialDiscount className="max-w-[1300px]" specialDiscounted={widgetsData?.data?.mostDiscountedWidget} />

    <NewSelection className="max-w-[1300px]" icon={<IconMobile width={30} height={30} />} title='جدید ترین ها' items={widgetsData?.data?.mostDiscountedWidget} />

    {/* <Offers featured={sliders?.data?.landingPage?.featured} /> */}

    <DiscountWidgets widgetsData={widgetsData} />

    <NewSelection className="max-w-[1300px]" icon={<IconMobile width={30} height={30} />} title='پرفروش ترین ها' items={widgetsData?.data?.bestSellingWidget} />

    {/* <BlogSection /> */}


  </>
  )
}

CmsPage.pageOptions = {
  Layout: DevLayoutNavigation,
} as PageOptions

export default CmsPage


export const getStaticProps: GetPageStaticProps = async ({ locale }) => {
  const client = graphqlSharedClient(locale)
  const staticClient = graphqlSsrClient(locale)

  const conf = client.query({ query: StoreConfigDocument })
  const page = staticClient.query({ query: DefaultPageDocument, variables: { url: `page/home` } })
  const layout = staticClient.query({ query: LayoutDocument, fetchPolicy: 'cache-first' })
  const menuContent = staticClient.query({ query: MegaMenuContentDocument })
  const storeLogo = staticClient.query({ query: storeLogoDocument });

  // todo(paales): Remove when https://github.com/Urigo/graphql-mesh/issues/1257 is resolved
  // const favoritesList = staticClient.query({
  //   query: ProductListDocument,
  //   variables: { pageSize: 8, filters: { category_uid: { eq: 'MTIx' } } },
  // })

  // const latestList = staticClient.query({
  //   query: ProductListDocument,
  //   variables: { pageSize: 8, filters: { category_uid: { eq: 'MTAy' } } },
  // })

  /*  const swipableList = staticClient.query({
      query: ProductListDocument,
      variables: { pageSize: 8, filters: { category_uid: { eq: 'MTIy' } } },
   }); */


  // if (!page.data.pages?.[0]) return { notFound: true }



  return {
    props: {
      ...(await page)?.data,
      ...(await layout)?.data,
      ...(await menuContent)?.data,
      ...(await storeLogo)?.data,
      // content: await getLandingContent(2),
      widgetsData: await getWidgetsData(allWidgetsData),
      sliders: await getWidgetsData(slidersWidgets),
      apolloState: await conf.then(() => client.cache.extract()),
    },
    revalidate: 60 * 2,
  }
}  
